<template>
  <b-button-group>
    <b-button
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-assign-secondary-process
      variant="outline-primary"
      class="mr-1"
    >
      {{ $t('DEBTIA_ASSIGN_SECONDARY_PROCESS') }}
    </b-button>
    <b-button
      v-if="$ability.can(constants.action.permissionCaseProcessChange, constants.resource.user) && user_type !== 'super-admin' && !(isFullyPaidActive && restrictFullPaymentActions)"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-change-case-process
      variant="outline-primary"
      class="mr-1"
    >
      {{ $t('DEBTIA_CHANGE_PROCESS') }}
    </b-button>
    <b-button
      v-if="($ability.can(constants.action.permissionGenerateAgreementPlan, constants.resource.user) && user_type !== 'super-admin' && (installmentplanstatus === 0 || installmentplanstatus === 404)) && caseStatus !== 2 && caseStatus !== 3 && caseStatus !== 0 && caseStatus !== null && !(isFullyPaidActive && restrictFullPaymentActions)"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-prevent-closing
      variant="outline-primary"
      class="mr-1"
      @click="openGenerateAgreementForm"
    >
      {{ $t('DEBTIA_AGREEMENT_LINK') }}
    </b-button>
    <b-button
      v-if="caseStatus === 0 || caseStatus === null"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-primary"
      class="mr-1"
      @click="debtCaseAction(1)"
    >
      {{ $t('DEBTIA_ACCEPT_CASE') }}
    </b-button>
    <b-button
      v-if="caseStatus === 0 || caseStatus === null"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-case
      variant="outline-danger"
      @click="getDebtCaseActionData(caseStateData, 'decline')"
    >
      {{ $t('DEBTIA_DECLINE_CASE') }}
    </b-button>
    <b-button
      v-if="!(isFullyPaidActive && restrictFullPaymentActions) && (caseStatus === 1 || caseStatus === 4) && caseState != 'pause'"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-case
      variant="outline-primary"
      @click="getDebtCaseActionData(caseStateData, 'pause')"
    >
      {{ $t('DEBTIA_PAUSE_CASE') }}
    </b-button>
    <b-button
      v-if="!(isFullyPaidActive && restrictFullPaymentActions) && (caseStatus === 1 || caseStatus === 4) && caseState === 'pause'"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-case
      variant="outline-primary"
      @click="getDebtCaseActionData(caseStateData, 'resume')"
    >
      {{ $t('DEBTIA_RESUME_CASE') }}
    </b-button>
    <b-button
      v-if="!(isFullyPaidActive && restrictFullPaymentActions) && (caseStatus === 1 || caseStatus === 4) && user_type !== 'super-admin' && $ability.can(constants.action.permissionCaseTermination, constants.resource.user)"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      v-b-modal.modal-case
      variant="outline-danger"
      @click="getDebtCaseActionData(caseStateData, 'terminate')"
    >
      {{ $t('DEBTIA_TERMINATE_CASE') }}
    </b-button>
    <b-button
      v-if="caseStatus === 2"
      id="popover-reactive-4"
      ref="button"
      v-ripple.400="'rgba(113, 102, 240, 0.15)'"
      variant="outline-danger"
      class="mr-1"
    >
      {{ $t('DEBTIA_DECLINED') }}
    </b-button>
    <b-button
      v-if="caseStatus === 3"
      id="popover-reactive-4"
      ref="button"
      v-ripple.400="'rgba(255, 159, 67, 0.15)'"
      variant="outline-danger"
      class="transaction-title pointer-name display-inline"
    >
      {{ $t('DEBTIA_TERMINATED') }}
    </b-button>
    <b-button
      v-if="caseStatus === 2 || caseStatus === 3"
      v-ripple.400="'rgba(255, 159, 67, 0.15)'"
      variant="outline-danger"
    >
      {{ 'Reason: ' + caseStateData.reason }}
    </b-button>
    <case-details-modal
      :case-data="showData"
      :selected-state="selectedState"
      :case-state="caseState"
      :b-title="bTitle"
      :b-varient="bVarient"
      :modal-loads="modalLoader"
      :show="!modalLoader"
      :reason-options="reasonOptions"
      :header-btn-pressed="headerBtnPressed"
      :create-invoice="createInvoice"
    />
    <agreement-link-modal
      :journal-id="bcCaseId.toString()"
      :case-id="caseId"
      :main-debtor-email="mainDebtorEmail"
      :main-debtor-phone="mainDebtorPhone"
      :modal-click-trigger="modalClickTrigger"
    />
    <case-process-change
      :case-id="parseInt(caseId)"
      :current-process-id="currentProcessID"
    />
    <assign-secondary-process
      :case-id="parseInt(caseId)"
      :secondary-processes-data="secondaryProcessesData"
      :get-secondary-processes="getSecondaryProcesses"
    />
    <await-till-date-modal
      ref="modalAwaitTillDate"
      :question="awaitTillQuestion"
      :process-name="awaitTillProcessName"
      :process-case-id="activeProcessId"
    />
    <b-popover
      v-if="caseStatus === 2 || caseStatus === 3"
      ref="popover"
      target="popover-reactive-4"
      triggers="hover"
      placement="auto"
      container="my-container"
      variant="danger"
    >
      <template #title>
        <div class="d-flex justify-content-between align-items-centers">
          <span v-if="caseStatus === 2">{{ $t('DEBTIA_CASE_DECLINED_BECAUSE') }}</span>
          <span v-if="caseStatus === 3">{{ $t('DEBTIA_CASE_TERMINATED_BECAUSE') }}</span>
        </div>
      </template>
      <table
        class="client-details-table table-border"
      >
        <tr
          v-if="caseStatus === 2"
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_DECLINED_BY') }}</td>
          <td class="right-values item-padding">
            {{ caseStateData.employee_name }}
          </td>
        </tr>
        <tr
          v-if="caseStatus === 2"
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_DECLINED_AT') }}</td>
          <td class="right-values item-padding">
            {{ caseStateData.en_log_created_at }}
          </td>
        </tr>
        <tr
          v-if="caseStatus === 3"
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_TERMINATED_BY') }}</td>
          <td class="right-values item-padding">
            {{ caseStateData.employee_name }}
          </td>
        </tr>
        <tr
          v-if="caseStatus === 3"
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_TERMINATED_AT') }}</td>
          <td class="right-values item-padding">
            {{ caseStateData.en_log_updated_at }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_REASON') }}</td>
          <td class="right-values item-padding">
            {{ caseStateData.reason }}
          </td>
        </tr>
        <tr
          class="business-item"
        >
          <td class="left-item-padding">
            {{ $t('DEBTIA_DESCRIPTION') }}</td>
          <td class="right-values item-padding">
            {{ caseStateData.description }}
          </td>
        </tr>
      </table>
    </b-popover>
  </b-button-group>
</template>

<script>
import {
  BButtonGroup, BButton, BPopover,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
// import store from '@/store'
import constants from '@/app-configs/constants'
import { EventBus } from '@/event-bus'
import axios from '@axios'
import AgreementLinkModal from '@/views/cases/AgreementLinkModal.vue'
import CaseProcessChange from '@/views/cases/CaseProcessChange.vue'
import AssignSecondaryProcess from '@/views/cases/AssignSecondaryProcess.vue'
import CaseDetailsModal from '../CaseDetailsModal.vue'
import AwaitTillDateModal from './AwaitTillDateModal.vue'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BButton,
    AgreementLinkModal,
    CaseProcessChange,
    BButtonGroup,
    BPopover,
    CaseDetailsModal,
    AssignSecondaryProcess,
    AwaitTillDateModal,
  },
  directives: {
    Ripple,
  },
  props: {
    caseStatus: {
      type: Number,
      required: true,
    },
    bcCaseId: {
      type: String,
      required: true,
    },
    caseStateData: {
      type: Object,
      required: true,
    },
    caseState: {
      type: String,
      required: true,
      default: '',
    },
    isFullyPaidActive: {
      type: Boolean,
      default: false,
    },
    restrictFullPaymentActions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      constants,
      modalClickTrigger: false,
      user_type: JSON.parse(localStorage.getItem('userData')).data.user_type,
      installmentplanstatus: 404,
      mainDebtorEmail: 'N/A',
      mainDebtorPhone: 'N/A',
      caseId: this.$route.params.id,
      currentProcessID: 0,
      bTitle: '',
      bVarient: '',
      showData: {},
      reasonOptions: [],
      selectedState: '',
      modalLoader: true,
      headerBtnPressed: '',
      createInvoice: false,
      secondaryProcessesData: [],
      secondaryUserActionModules: [],
      awaitTillQuestion: '',
      awaitTillProcessName: '',
      user_role: JSON.parse(localStorage.getItem('userData')).role[0],
      activeProcessId: 0,
      modalQueue: [],
      isModalShowing: false,
      primaryCheckDone: false,
      handledProcessCaseIds: [],
    }
  },
  created() {
    this.getClient()
    this.getSecondaryProcesses()
    this.loader = true
    EventBus.$on('getInstallmentPlanStatus', data => {
      this.installmentplanstatus = data
    })
    EventBus.$on('setRemainingDebtAmount', data => {
      this.setRemainingDebtAmountMetho(data)
    })
    EventBus.$on('setCreditorId', data => {
      this.setCreditorIdMethod(data)
    })
    EventBus.$on('getMainDebtorInformation', data => {
      this.mainDebtorEmail = data.email
      this.mainDebtorPhone = data.phone
    })
    EventBus.$on('getFirstProcessId', data => {
      this.currentProcessID = data
    })
    EventBus.$on('refreshSecondaryProcesses', () => {
      this.getSecondaryProcesses()
    })
    EventBus.$on('queueAwaitModal', item => {
      if (this.handledProcessCaseIds.includes(item.processCaseId)) return
      this.handledProcessCaseIds.push(item.processCaseId)
      if (item.source === 'primary') {
        this.modalQueue.unshift(item)
      } else {
        this.modalQueue.push(item)
      }
    })
    EventBus.$on('primaryModalCheckDone', () => {
      this.primaryCheckDone = true
      this.processModalQueue()
    })
    this.$root.$on('bv::modal::hidden', bvEvent => {
      if (bvEvent.componentId === 'awaitTillDateModal') {
        this.isModalShowing = false
        this.processModalQueue()
      }
    })
    this.getReasonOptions()
  },
  methods: {
    async getClient() {
      const caseID = this.caseId
      const url = `${constants.baseUrlV2}/debt-case/client-data/${caseID}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.client = response.data.data.client
          this.createInvoice = (this.client.bc_customer_id.length > 0)
        }
      })
    },
    async getSecondaryProcesses() {
      this.secondaryUserActionModules = []
      this.secondaryProcessesData = []
      const caseID = this.caseId
      const url = `${constants.baseUrlV2}/debt-case/secondary-process-data/${caseID}`
      await axios.get(url).then(response => {
        if (response.status === 200) {
          const { process_cases } = response.data.data
          process_cases.forEach(element => {
            const settings = element.process_data.active_module.module_settings
            const awaitingFiles = Array.isArray(settings) ? settings : []
            const obj = {
              process_id: element.id,
              process_title: element.process.title,
              current_module: element.process_data.active_module.module_title,
              error: element.error,
              next_module: element.process_data.next_module ? element.process_data.next_module.module_title : 'N/A',
              execution_date: element.process_data.active_module.module_settings.execution_date,
              en_execution_date: element.process_data.active_module.module_settings.en_execution_date,
              da_execution_date: element.process_data.active_module.module_settings.da_execution_date,
              awaiting_files: awaitingFiles,
            }
            this.secondaryProcessesData.push(obj)
            if (element.process_data.active_module.module_id === 9) {
              this.secondaryUserActionModules.push(element.process_data.userActions)
            }
            if (element.process_data.active_module.module_id === 24
              && element.process_data.active_module.module_settings.execution_date === null
              && !this.handledProcessCaseIds.includes(element.id)) {
              this.handledProcessCaseIds.push(element.id)
              const awaitQuestion = element.process_data.active_module.module_settings.question ?? ''
              const processName = element.process_name ?? ''
              this.modalQueue.push({
                question: awaitQuestion,
                processCaseId: element.id,
                source: 'secondary',
                processName,
              })
            }
          })
          const secondaryObject = {
            userActionModule: this.secondaryUserActionModules,
            otherModules: this.secondaryProcessesData,
            isProcessCasesEmpty: process_cases.length === 0,
          }
          if (this.primaryCheckDone) {
            this.processModalQueue()
          }
          EventBus.$emit('refreshSecondaryModules', secondaryObject)
        }
      })
    },
    // getFormattedDate(createdAtDate) {
    //   // Create a Date object from the date string
    //   const date = new Date(createdAtDate)

    //   // Define options for formatting
    //   const options = {
    //     month: 'long',
    //     day: 'numeric',
    //     year: 'numeric',
    //     hour: 'numeric',
    //     minute: 'numeric',
    //     hour12: false, // Use 'true' if you prefer 12-hour format with AM/PM
    //   }

    //   // Format the date
    //   const formattedDate = date.toLocaleString('en-US', options)
    //   return formattedDate
    // },
    processModalQueue() {
      if (this.isModalShowing || this.modalQueue.length === 0) return
      const next = this.modalQueue.shift()
      this.awaitTillQuestion = next.question
      this.awaitTillProcessName = next.processName ?? ''
      this.activeProcessId = next.processCaseId
      this.isModalShowing = true
      this.$nextTick(() => {
        this.$bvModal.show('awaitTillDateModal')
      })
    },
    async debtCaseAction(status) {
      await axios.post(`${constants.baseUrl}/approve-debt-case`, {
        debt_case_id: this.caseId,
        status,
      }).then(response => {
        if (response.status === 200) {
          EventBus.$emit('refreshStatmentWidget')
          EventBus.$emit('refreshStateData')
          EventBus.$emit('refreshModules')
        }
      })
    },
    async getReasonOptions() {
      const url = '/get-reason-options'
      await axios.get(url).then(response => {
        if (response.status === 200) {
          this.reasonOptions = response.data.data
        }
      })
    },
    openGenerateAgreementForm() {
      this.modalClickTrigger = !this.modalClickTrigger
    },
    copyCode(id) {
      let codeToCopy = ''
      if (id === 'copy-bc-case-id') {
        codeToCopy = document.querySelector(`#${id}`)
      }
      if (id === 'copy-case-id') {
        codeToCopy = document.querySelector(`#${id}`)
      }
      codeToCopy.setAttribute('type', 'text')
      codeToCopy.select()
      try {
        document.execCommand('copy')

        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Text copied',
            icon: 'BellIcon',
          },
        })
      } catch (err) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Failed to copy texts!',
            icon: 'BellIcon',
          },
        })
      }
      /* unselect the range */
      codeToCopy.setAttribute('type', 'hidden')
      window.getSelection().removeAllRanges()
    },
    setRemainingDebtAmountMetho(data) {
      this.caseStateData.remaining_debt_amount = data
    },
    setCreditorIdMethod(data) {
      this.caseStateData.creditor_id = data
    },
    async getDebtCaseActionData(item, state) {
      if (state === 'decline') {
        this.headerBtnPressed = 'decline'
        this.bTitle = this.$t('DEBTIA_DECLINE_CASE')
        this.bVarient = 'danger'
      }
      if (state === 'terminate') {
        this.headerBtnPressed = 'terminate'
        this.bTitle = this.$t('DEBTIA_TERMINATE_CASE')
        this.bVarient = 'danger'
      }
      if (state === 'pause') {
        this.headerBtnPressed = 'pause'
        this.bTitle = this.$t('DEBTIA_PAUSE_CASE')
        this.bVarient = 'warning'
      }
      if (state === 'resume') {
        this.headerBtnPressed = 'resume'
        this.bTitle = this.$t('DEBTIA_RESUME_CASE')
        this.bVarient = 'primary'
      }
      this.modalLoader = true
      this.showData = { ...item }
      if (state === 'pause' || state === 'terminate' || state === 'decline') {
        this.showData.description = ''
      }
      this.selectedState = (state === 'decline') ? 'terminate' : state
      this.modalLoader = false
    },
  },
}
</script>

<style lang="scss">
</style>
